import React from 'react'
import { Box, Grid } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import MuiFilterSelect from '../../../components/Filters/MuiFilterSelect'
import { MUI_DATE_PICKER_ES_LOCALE_TEXT } from '../../../components/constants/muiDatePickerEsLocaleText'
import { MobileAdvancedFilterDrawer } from '../../../components/mobile'
import { MOBILE_ADVANCED_FILTER_FIELD_SX } from '../../../components/mobile/styles/mobileAdvancedFilterSx'

export default function RouteExecutionMobileFilters({
  query,
  handleSearchChange,
  handleSearchKeyDown,
  searchInputRef,
  clearSearch,
  openFilters,
  appliedFilterGroupCount,
  appliedFilterChips,
  isOpen,
  closeFilters,
  mobileFilterConfigs,
  draftFilterSelections,
  buildSelectValue,
  handleDraftSelectChange,
  anyFilterEmpty,
  plannedDateRangeCard,
  executedDateRangeCard,
  clearAllFilters,
  applyFilters
}) {
  return (
    <MobileAdvancedFilterDrawer
      textSizeOffset={-3}
      title="Filtrar visitas por"
      drawerTitle="Filtros de visitas"
      query={query}
      onQueryChange={handleSearchChange}
      onQueryKeyDown={handleSearchKeyDown}
      onClearQuery={clearSearch}
      searchInputRef={searchInputRef}
      searchPlaceholder="Buscar ..."
      isOpen={isOpen}
      onOpen={openFilters}
      onClose={closeFilters}
      appliedFilterGroupCount={appliedFilterGroupCount}
      appliedFilterChips={appliedFilterChips}
      onClearAll={clearAllFilters}
      onApply={applyFilters}
      filterFieldsContent={
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="es"
          localeText={MUI_DATE_PICKER_ES_LOCALE_TEXT}
        >
          <Grid container spacing={2}>
            {mobileFilterConfigs.map((filter) => (
              <Grid key={filter.key} size={{ xs: 12, sm: 6 }} sx={{ minWidth: 0 }}>
                <Box sx={MOBILE_ADVANCED_FILTER_FIELD_SX}>
                  <MuiFilterSelect
                    title={filter.key}
                    options={filter.options}
                    value={draftFilterSelections[filter.key] || buildSelectValue()}
                    onChange={(nextValue) => handleDraftSelectChange(filter.key, nextValue)}
                    disabled={anyFilterEmpty || filter.options.length === 0}
                    width="100%"
                    matchTriggerWidth
                    inlineDropdown
                    autoFocusSearch={false}
                    onSearchChange={filter.onSearchChange}
                    onLoadMore={filter.onLoadMore}
                    hasMore={filter.hasMore}
                    loading={filter.loading}
                  />
                </Box>
              </Grid>
            ))}

            <Grid size={{ xs: 12, sm: 6 }} sx={{ minWidth: 0 }}>
              {plannedDateRangeCard}
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ minWidth: 0 }}>
              {executedDateRangeCard}
            </Grid>
          </Grid>
        </LocalizationProvider>
      }
    />
  )
}
